import validate from 'validate.js';

import { EnumNamesInputs, DataPersonInfoState } from '../../types/form.types';
import { ErrorsInterface } from '../../types/errorInput.types';
import moment from 'moment';
import 'moment/locale/es';

export const isFormValid = (state: DataPersonInfoState): ErrorsInterface => {
  validate.extend(validate.validators.datetime, {
    parse: (value: string) => {
      const isValid = moment(value, 'DD/MM/YYYY', true).isValid();
      const parsedDate = moment(value, 'DD/MM/YYYY', true);
      return isValid ? +moment.utc(parsedDate) : NaN;
    },
    format: (value: string) => {
      return moment.utc(value).format('DD/MM/YYYY');
    },
  });

  const constrains = {
    [EnumNamesInputs.RFC]: {
      length: {
        minimum: 12,
        maximum: 13,
        message: '^Introduce al menos 12 caracteres de tu RFC',
      },
    },
    [EnumNamesInputs.FIRST_NAME]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu nombre',
      },
      format: {
        pattern: '[A-Za-zÀ-ÿ ´]{2,30}',
        message: '^Escribe al menos 2 caracteres',
      },
    },
    [EnumNamesInputs.SECOND_NAME]: {
      type: 'string',
      format: {
        pattern: '[A-Za-zÀ-ÿ ´]{0,30}',
        message: '^Escribe al menos 2 caracteres',
      },
    },
    [EnumNamesInputs.FIRST_LAST_NAME]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu primer apellido',
      },
      format: {
        pattern: '[A-Za-zÀ-ÿ ´]{2,30}',
        message: '^Escribe al menos 2 caracteres',
      },
    },
    [EnumNamesInputs.SECOND_LAST_NAME]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu segundo apellido',
      },
      format: {
        pattern: '[A-Za-zÀ-ÿ ´]{2,30}',
        message: '^Escribe al menos 2 caracteres',
      },
    },
    [EnumNamesInputs.BIRTH_DATE]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu fecha de nacimiento',
      },
      datetime: {
        message: '^Fecha de nacimiento inválida',
        earliest: moment.utc().subtract(80, 'years'),
        latest: moment.utc().subtract(18, 'years'),
        tooEarly: '^Debes tener menos de 80 años',
        tooLate: '^Debes tener al menos 18 años',
      },
    },
    [EnumNamesInputs.PHONE_NUMBER]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu número de teléfono',
      },
      format: {
        pattern: '[0-9]{2}-[0-9]{4}-[0-9]{4}',
        message: '^El número de teléfono debe tener 10 caracteres',
      },
    },
    [EnumNamesInputs.EMAIL]: {
      presence: {
        allowEmpty: false,
        message: '^Ingresa tu correo electrónico',
      },
      email: {
        message: '^Correo electrónico inválido',
      },
    },
  };
  return validate(state, constrains);
};
